/**
 * Whether the browser reports the device as offline (`navigator.onLine`).
 *
 * DIAGNOSTIC ONLY. Dictation surfaces the same COULD_NOT_CONNECT_TO_HEIDI error
 * whether or not the device reports offline — an unreachable Heidi is the same
 * outcome to the app either way. This value is logged as `device_reported_offline`
 * on connect failures so Datadog can tell a genuinely offline device apart from
 * a can't-reach-Heidi case (host/regional endpoint down, DNS failure, TLS
 * handshake failure, proxy/firewall block) while the device is still online.
 *
 * `navigator.onLine` is only meaningful in the offline direction: `false`
 * reliably means no network, while `true` does NOT guarantee reachability. Do
 * not use it to gate or block dictation — it is a signal for logs, not control
 * flow.
 *
 * SSR-safe: returns `false` when `navigator` is unavailable, so we never claim
 * "offline" outside the browser.
 */
export function isDeviceOffline(): boolean {
  if (typeof navigator === 'undefined') return false;
  return navigator.onLine === false;
}
